// extracted by mini-css-extract-plugin
export default {"title":"SharedPicker-module__title--ljVp1"};